import { Toast } from 'drywall';
import { css } from 'styled-components';
import token from 'styled-token';
import { StyledHeading } from '../../components/Heading/Heading.styles';
import { StyledText } from '../../components/Text/Text.styles';
import { StyledTextButton } from '../../components/TextButton/TextButton.styles';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { mediaBreakpointMixin } from '../mediaBreakpointMixin';
import { mediaQueryMixin } from '../mediaQueryMixin';
import { statusDialogMixin } from '../statusDialogMixin';
import { typographyMixin } from '../typographyMixin';
import { BannerMixin } from './BannerMixin';
var mobileCSS = token({
  mediaSize: 'UpsellBanner.mediaSize',
  closeSize: 'CloseButton.buttonSize',
  padding: 'UpsellBanner.padding'
}, function (_ref) {
  var mediaSize = _ref.mediaSize,
    closeSize = _ref.closeSize,
    padding = _ref.padding;
  return css(["flex-direction:column;align-items:flex-start;min-height:", "px;padding-left:", "px;padding-right:", "px;position:relative;", "{position:absolute;top:", "px;left:", "px;}", "{position:absolute;top:", "px;right:", "px;}", "{margin:0;& ", "{text-align:start;}}"], 2 * padding + mediaSize, 2 * padding + mediaSize, 2 * padding + closeSize, Toast.Icon, padding, padding, Toast.Close, padding, padding, Toast.Action, StyledTextButton);
});
var showBodyCSS = inlineMediaQueryMixin('showBody', function (_ref2) {
  var showBody = _ref2.showBody;
  return css(["", " + ", "{display:", ";}"], StyledHeading, StyledText, showBody ? 'initial' : 'none');
});
var colorCSS = function colorCSS(props) {
  var background = props.background;
  return token({
    backgroundColor: "colors." + background,
    boxShadow: 'Upsell.boxShadow'
  }, {
    defaultValue: ''
  }, function (tokens) {
    var styles = ["background: " + tokens.backgroundColor + ";"];
    if (background === 'backgroundBrand') {
      styles.push(statusDialogMixin(Object.assign({
        inverse: true
      }, props)));
      // Need to add BannerMixin again to override statusDialogMixin values
      styles.push(BannerMixin(props));
    }
    if (background === 'backgroundWhite') {
      styles.push("box-shadow: " + tokens.boxShadow + ";");
    }
    return styles;
  });
};

/** @class UpsellBannerMixin */
/** @method */
export var UpsellBannerMixin = function UpsellBannerMixin(props) {
  return token({
    fontType: 'UpsellBanner.fontType',
    mediaSize: 'UpsellBanner.mediaSize'
  }, function (tokens) {
    return css(["align-items:center;border:0;", "{display:inline;", "}", "", "{height:", "px;width:", "px;}", "", "{flex-shrink:1;}", " @media ", "{", "}", " ", ""], StyledHeading, typographyMixin(Object.assign({
      fontType: tokens.fontType
    }, props)), Toast.Icon, Toast.Icon, tokens.mediaSize, tokens.mediaSize, Toast.Body, Toast.Body, colorCSS(props), mediaBreakpointMixin('sm_lte'), mobileCSS(props), showBodyCSS(props), mediaQueryMixin(function (mediaProps) {
      return showBodyCSS(Object.assign({}, mediaProps));
    }));
  })(props);
};